<template>
  <div class="profile-tree" v-loading="!isTreeLoaded">
    <tree
      :cicled="cicled"
      :bordered="bordered"
      :data="treeData"
      :module="module"
      :edit-mode="editMode"
      :show-tools="showTools"
      :node-click-handler="nodeClickHandler"
      :active-layers="activeLayers"
      :active-layers-id="activeLayersId"
      :dark-mode="darkMode"
      :toggle-tool="toggleTool"
      :is-active="isActive"
      :is-loading="isLoading"
    />
  </div>
</template>

<script>
import tree from "@/components/tree/tree";

export default {
  components: { tree },
  props: {
    "active-layers": String,
    "active-layers-id": String,
    cicled: Boolean,
    bordered: Boolean,
    "dark-mode": Boolean,
    "edit-mode": Boolean,
    "is-active": Function,
    "is-loading": Function,
    "toggle-tool": Function,
    "show-tools": Boolean,
    module: String,
    "node-click-handler": Function
  },
  data() {
    return {
      isTreeLoaded: false,
      currentProfileId: this.$store.state.profiles.currentProfile.id,
      treeData: []
    };
  },
  watch: {
    "$store.state.profiles.isTreeLoaded": {
      handler: function(val) {
        this.isTreeLoaded = val;
      },
      deep: true,
      immediate: true
    },
    "$store.state.profiles.isUpdated.toggle": {
      handler: function(val) {
        if (!val && this.module !== "constructorTree") return;
        this.updateTree();
        this.$store.commit("PROFILE_TREE_UPDATED", {
          action: "toggle",
          value: false
        });
      },
      deep: true,
      immediate: true
    },
    "$store.state.profiles.isUpdated.dnd": {
      handler: function(val) {
        if (!val || this.module === "constructorTree") return;
        this.updateTree();
        this.$store.commit("PROFILE_TREE_UPDATED", {
          action: "dnd",
          value: false
        });
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    constructorProfileId() {
      return this.$store.state.profiles.profileConstructor.profileId;
    }
  },
  methods: {
    mapTreeConstructor(data) {
      return data.filter(e => {
        const { geom_type, datatype } = e;
        if (e.children) {
          e.children = this.mapTreeConstructor(e.children);
        }
        const children = e.children;

        return !(!geom_type && datatype !== "tile_layer" && !children);
      });
    },
    // mapTreeConstructor(data) {
    //   let i = data.length;
    //   while (i) {
    //     const currentData = data[i - 1];
    //     const { geom_type } = currentData;
    //     const childrens = currentData.children ? currentData.children : [];

    //     this.mapTreeConstructor(childrens);
    //     if (
    //       !geom_type &&
    //       currentData.children &&
    //       !currentData.children.length
    //     ) {
    //       data.splice(i - 1, 1);
    //     } else if (!geom_type && !currentData.children) {
    //       data.splice(i - 1, 1);
    //     }
    //     i--;
    //   }

    //   return data;
    // },
    async updateTree() {
      let response;

      if (this.module === "constructorTree") {
        response = await this.$store.dispatch("REQUEST", {
          url: `profile_tree?profile_id=${this.constructorProfileId}`
        });
      } else {
        response = await this.$store.dispatch("REQUEST", {
          url: `profile_tree?profile_id=${this.currentProfileId}`
        });
      }

      const { data } = response;

      this.treeData = this.sortData(data.profile_trees);
      if (this.module === "mapTree") this.mapTreeConstructor(this.treeData);
      this.$store.commit("SET_CURRENT_PROFILE_TREE", this.treeData);
    },
    sortData(data) {
      const sortedData = data.sort((a, b) => {
        if (a.source_id && !b.source_id) return 1;
        if (!a.source_id && b.source_id) return -1;
        if (a.datatype !== "model" && b.datatype === "model") return 1;
        if (a.datatype === "model" && b.datatype !== "model") return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;

        return 0;
      });

      return sortedData;
    }
  },
  async created() {
    this.$store.commit("SET_TREE_LOADED", false);
    this.$store.commit("CLEAR_CHECKED_DATA", true);

    let response;

    if (this.module === "constructorTree") {
      response = await this.$store.dispatch("REQUEST", {
        url: `profile_tree?profile_id=${this.constructorProfileId}`
      });
    } else {
      response = await this.$store.dispatch("REQUEST", {
        url: `profile_tree?profile_id=${this.currentProfileId}`
      });
    }

    const { data } = response;

    this.treeData = this.sortData(data.profile_trees);
    if (this.module === "mapTree") {
      this.treeData = this.mapTreeConstructor(this.treeData);
    }
    this.$store.commit("SET_CURRENT_PROFILE_TREE", this.treeData);
    this.$store.commit("SET_TREE_LOADED", true);
  }
};
</script>

<style lang="scss">
.profile-tree {
  position: relative;
  height: 100%;
  overflow: hidden;
}
</style>

<i18n>
{
  "ru": {
    "Settings": "Настройки",
    "Book": "Справочник",
    "Editor": "Редактор геометрии",
    "flyToLayer": "Перелететь к слою",
    "enableRouter": "Запустить маршрутизатор",
    "startCalc": "Запустить расчет"
  },
  "en": {
    "Settings": "Settings",
    "Book": "Book",
    "Editor": "Editor",
    "flyToLayer": "Fly To Layer",
    "enableRouter": "Start Router",
    "startCalc": "Start Calculation"
  }
}
</i18n>
